import { TreePicklistItemResponse } from "../../TreePicklistItemProvider";
import { TreePicklistItem } from "../../TreePicklistItem";
import { splitArrayByPredicate } from "../../../../../../../../Common/ArrayUtils";

export const filterUnnecessaryCheckedChildren = async (
    currentValue: TreePicklistItem[]
): Promise<TreePicklistItemResponse[]> => {
    const ancestorsOnly = filterNodesWhichHaveSelectedAncestor(currentValue);

    const [availableForSavingNodes, notAvailableForSavingNodes] =
        splitSelectedNodesByAvailabilityForSaving(ancestorsOnly);

    const readyForSavingDescendants =
        await getItemsResponsesFromFirstLevelAvailableForSaving(notAvailableForSavingNodes);

    const itemsResponsesReadyForSaving = availableForSavingNodes
        .map(item => item.toOriginal())
        .concat(readyForSavingDescendants);

    return itemsResponsesReadyForSaving;
};

function filterNodesWhichHaveSelectedAncestor(selectedNodes: TreePicklistItem[]) {
    return selectedNodes.filter(value1 => {
        const hasAncestorInCurrentValue = selectedNodes.some(value2 => value1.hasAncestorWithId(value2.elementId));

        return !hasAncestorInCurrentValue;
    });
}

function splitSelectedNodesByAvailabilityForSaving(selectedNodes: TreePicklistItem[]) {
    return splitArrayByPredicate(selectedNodes, item => item.isAvailableForSaving);
}

async function getItemsResponsesFromFirstLevelAvailableForSaving(treeItems: TreePicklistItem[]) {
    const itemsResponses = treeItems.map(async item => item.fetchNearestNodesAvailableForSaving());

    return (await Promise.all(itemsResponses)).flat();
}
